<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<div class="task_properties" fxLayout="row" fxLayoutAlign="start center" *ngIf="date">
  <span class="task_properties_title">{{ label }}</span>
  <span class="task_properties_value">{{ formattedDate }}</span>
</div>
